const n = "{{currentTime}} z {{duration}}", t = "Wyniki wyszukiwania: {{current}} z {{total}}", o = "Brak wyników", s = "{{count}} odnaleziony wynik", c = "Odnalezione wyniki: {{count}}", a = 'Odtwarzanie od $t(HOURS, { "count": {{hours}} }), $t(MINUTES, { "count": {{minutes}} }) oraz $t(SECONDS, { "count": {{seconds}} }).', A = 'Odtwarzanie od $t(MINUTES, { "count": {{minutes}} }) oraz $t(SECONDS, { "count": {{seconds}} }).', E = 'Odtwarzanie od $t(SECONDS, { "count": {{seconds}} }).', i = "Błąd podczas zapisywania w transkrypcji.", T = "Wiesz transkrypcji dla {{time}}. Zawartość: {{text}}.", _ = 'Kontener wierszy transkrypcji. Wiersze transkrypcji w tym kontenerze: $t(TRANSCRIPT_LINES, { "count": {{count}} }). Aby przejść do tego kontenera, użyć strzałki w dół.', e = "Zapisywanie zmian...", S = "Zmiany zapisane w transkrypcji.", r = "Dostępny jest teraz przycisk aktualizacji napisów.", z = "Czynność", N = "Dodaj adnotację o {{time}}", O = "Dodaj pytanie o {{time}}", R = "Adnotacje", I = "Automatyczna", y = "Automatyczna ({{quality}})", P = "Wstecz", C = "Napisy", w = "Język napisów", k = "Zarządzaj napisami", U = "Usuń {{language}}", d = "Rozmiar czcionki", u = "Język napisów: {{language}}", p = "{{language}} (automatycznie)", L = "Wyczyść wyszukiwanie", D = "Zamknij", j = "Komentarze", M = "Kontynuuj", m = "Zmniejsz prędkość odtwarzania", G = "Zmniejsz głośność o {{percent}}%", Y = "Strzałka w dół", l = "Zamknij edytor transkrypcji", W = "Aktualizuj napisy", H = "Błąd!", g = "Zapisywanie...", B = "Zapisano!", Z = "Edytuj transkrypcję", K = "Tekst nie może być pusty!", V = "Pełny ekran", F = "{{count}} godz.", J = "{{count}} godz.", $ = "Zwiększ prędkość odtwarzania", h = "Zwiększ głośność o {{percent}}%", Q = "Odwróć kolory", b = "Przejdź do określonego poziomu (1-10%, 2-20% itp.)", x = "Przejdź na początek", X = "Działania dot. {{title}}", f = "Skróty klawiaturowe", q = "Język", v = "Strzałka w lewo", nn = "Menu główne", tn = "{{count}} minuta", on = "{{count}} min", sn = "Wycisz", cn = "Wyciszone", an = "Następny język napisów", An = "Następny wynik wyszukiwania", En = "Wył.", Tn = "Na górze", _n = "Otwórz adnotację o {{time}}", en = "Otwórz ukończony test o {{time}}", Sn = "Otwórz test o {{time}}", rn = "Pauza", zn = "Odtwórz", Nn = "Prędkość odtwarzania", On = "Prędkość odtwarzania: {{speed}}x", Rn = "Poprzedni język napisów", In = "Poprzedni wynik wyszukiwania", yn = "Jakość", Pn = "Menu jakości", Cn = "Odtwórz", wn = "Resetuj prędkość odtwarzania", kn = "Strzałka w prawo", Un = "Wyszukaj w transkrypcji", dn = "{{count}} s", un = "{{count}} s", pn = "Wyszukaj do tyłu: {{seconds}} s", Ln = "Wyszukaj do przodu: {{seconds}} s", Dn = "Ustawienia", jn = "Skrót", Mn = "Szczegóły multimediów i narzędzia", mn = "Spacja", Gn = "Menu prędkości odtwarzania", Yn = "Rozpocznij automatyczne przewijanie", ln = "Przełącz napisy", Wn = "Przełącz wyciszenie", Hn = "Przełącz odtwarzanie/wstrzymanie", gn = "jest {{count}} wiersz transkrypcji", Bn = "istnieją {{count}} wiersze transkrypcji", Zn = "Wczytywanie transkrypcji...", Kn = "Nie udało się wczytać transkrypcji.", Vn = "Opcje transkrypcji", Fn = "Ponów próbę", Jn = "Transkrypcja niedostępna", $n = "Strzałka w górę", hn = "Ustawienia wideo", Qn = "Głośność", bn = "Głośność: {{volume}}%", xn = {
  A11Y_DURATION: n,
  A11Y_SEARCH_HITS: t,
  A11Y_SEARCH_NO_RESULTS: o,
  A11Y_SEARCH_RESULTS_FOUND: s,
  A11Y_SEARCH_RESULTS_FOUND_other: c,
  A11Y_TIMESTAMP_JUMP_HOURS: a,
  A11Y_TIMESTAMP_JUMP_MINUTES: A,
  A11Y_TIMESTAMP_JUMP_SECONDS: E,
  A11Y_TRANSCRIPT_ERROR: i,
  A11Y_TRANSCRIPT_LINE: T,
  A11Y_TRANSCRIPT_LINES: _,
  A11Y_TRANSCRIPT_SAVING: e,
  A11Y_TRANSCRIPT_SUCCESS: S,
  A11Y_UPDATE_CAPTIONS_AVAILABLE: r,
  ACTION: z,
  ADD_ANNOTATION_AT: N,
  ADD_QUESTION_AT: O,
  ANNOTATIONS: R,
  AUTO: I,
  AUTO_QUALITY: y,
  BACK: P,
  CAPTIONS: C,
  CAPTIONS_LANGUAGE: w,
  CAPTIONS_MANAGE: k,
  CAPTION_DELETE: U,
  CAPTION_FONT_SIZE: d,
  CAPTION_LANGUAGE: u,
  CAPTION_LANGUAGE_AUTOMATIC: p,
  CLEAR_SEARCH: L,
  CLOSE: D,
  COMMENTS: j,
  CONTINUE: M,
  DECREASE_PLAYBACK_SPEED: m,
  DECREASE_VOLUME: G,
  DOWN_ARROW: Y,
  EDIT_CLOSE: l,
  EDIT_CONFIRM: W,
  EDIT_ERROR: H,
  EDIT_SAVING: g,
  EDIT_SUCCESS: B,
  EDIT_TRANSCRIPT: Z,
  EDIT_VALIDATION_ERROR: K,
  FULLSCREEN: V,
  HOURS: F,
  HOURS_other: J,
  INCREASE_PLAYBACK_SPEED: $,
  INCREASE_VOLUME: h,
  INVERT_COLORS: Q,
  JUMP_TO_PERCENTAGE: b,
  JUMP_TO_START: x,
  KEBAB_MENU: X,
  KEYBOARD_SHORTCUTS: f,
  LANGUAGE: q,
  LEFT_ARROW: v,
  MAIN_MENU: nn,
  MINUTES: tn,
  MINUTES_other: on,
  MUTE: sn,
  MUTED: cn,
  NEXT_CAPTION_LANGUAGE: an,
  NEXT_HIT: An,
  OFF: En,
  ON_TOP: Tn,
  OPEN_ANNOTATION_AT: _n,
  OPEN_COMPLETED_QUIZ_AT: en,
  OPEN_QUIZ_AT: Sn,
  PAUSE: rn,
  PLAY: zn,
  PLAYBACK_SPEED: Nn,
  PLAYBACK_SPEED_MESSAGE: On,
  PREVIOUS_CAPTION_LANGUAGE: Rn,
  PREVIOUS_HIT: In,
  QUALITY: yn,
  QUALITY_MENU: Pn,
  REPLAY: Cn,
  RESET_PLAYBACK_SPEED: wn,
  RIGHT_ARROW: kn,
  SEARCH_TRANSCRIPT_PLACEHOLDER: Un,
  SECONDS: dn,
  SECONDS_other: un,
  SEEK_BACKWARD: pn,
  SEEK_FORWARD: Ln,
  SETTINGS: Dn,
  SHORTCUT: jn,
  SIDEBAR: Mn,
  SPACE: mn,
  SPEED_MENU: Gn,
  START_AUTOSCROLL: Yn,
  TOGGLE_CAPTIONS: ln,
  TOGGLE_MUTED: Wn,
  TOGGLE_PLAY_PAUSE: Hn,
  TRANSCRIPT_LINES: gn,
  TRANSCRIPT_LINES_other: Bn,
  TRANSCRIPT_LOADING: Zn,
  TRANSCRIPT_LOAD_ERROR: Kn,
  TRANSCRIPT_OPTIONS: Vn,
  TRANSCRIPT_RETRY: Fn,
  TRANSCRIPT_UNAVAILABLE: Jn,
  UP_ARROW: $n,
  VIDEO_SETTINGS: hn,
  VOLUME: Qn,
  VOLUME_VALUE: bn
};
export {
  n as A11Y_DURATION,
  t as A11Y_SEARCH_HITS,
  o as A11Y_SEARCH_NO_RESULTS,
  s as A11Y_SEARCH_RESULTS_FOUND,
  c as A11Y_SEARCH_RESULTS_FOUND_other,
  a as A11Y_TIMESTAMP_JUMP_HOURS,
  A as A11Y_TIMESTAMP_JUMP_MINUTES,
  E as A11Y_TIMESTAMP_JUMP_SECONDS,
  i as A11Y_TRANSCRIPT_ERROR,
  T as A11Y_TRANSCRIPT_LINE,
  _ as A11Y_TRANSCRIPT_LINES,
  e as A11Y_TRANSCRIPT_SAVING,
  S as A11Y_TRANSCRIPT_SUCCESS,
  r as A11Y_UPDATE_CAPTIONS_AVAILABLE,
  z as ACTION,
  N as ADD_ANNOTATION_AT,
  O as ADD_QUESTION_AT,
  R as ANNOTATIONS,
  I as AUTO,
  y as AUTO_QUALITY,
  P as BACK,
  C as CAPTIONS,
  w as CAPTIONS_LANGUAGE,
  k as CAPTIONS_MANAGE,
  U as CAPTION_DELETE,
  d as CAPTION_FONT_SIZE,
  u as CAPTION_LANGUAGE,
  p as CAPTION_LANGUAGE_AUTOMATIC,
  L as CLEAR_SEARCH,
  D as CLOSE,
  j as COMMENTS,
  M as CONTINUE,
  m as DECREASE_PLAYBACK_SPEED,
  G as DECREASE_VOLUME,
  Y as DOWN_ARROW,
  l as EDIT_CLOSE,
  W as EDIT_CONFIRM,
  H as EDIT_ERROR,
  g as EDIT_SAVING,
  B as EDIT_SUCCESS,
  Z as EDIT_TRANSCRIPT,
  K as EDIT_VALIDATION_ERROR,
  V as FULLSCREEN,
  F as HOURS,
  J as HOURS_other,
  $ as INCREASE_PLAYBACK_SPEED,
  h as INCREASE_VOLUME,
  Q as INVERT_COLORS,
  b as JUMP_TO_PERCENTAGE,
  x as JUMP_TO_START,
  X as KEBAB_MENU,
  f as KEYBOARD_SHORTCUTS,
  q as LANGUAGE,
  v as LEFT_ARROW,
  nn as MAIN_MENU,
  tn as MINUTES,
  on as MINUTES_other,
  sn as MUTE,
  cn as MUTED,
  an as NEXT_CAPTION_LANGUAGE,
  An as NEXT_HIT,
  En as OFF,
  Tn as ON_TOP,
  _n as OPEN_ANNOTATION_AT,
  en as OPEN_COMPLETED_QUIZ_AT,
  Sn as OPEN_QUIZ_AT,
  rn as PAUSE,
  zn as PLAY,
  Nn as PLAYBACK_SPEED,
  On as PLAYBACK_SPEED_MESSAGE,
  Rn as PREVIOUS_CAPTION_LANGUAGE,
  In as PREVIOUS_HIT,
  yn as QUALITY,
  Pn as QUALITY_MENU,
  Cn as REPLAY,
  wn as RESET_PLAYBACK_SPEED,
  kn as RIGHT_ARROW,
  Un as SEARCH_TRANSCRIPT_PLACEHOLDER,
  dn as SECONDS,
  un as SECONDS_other,
  pn as SEEK_BACKWARD,
  Ln as SEEK_FORWARD,
  Dn as SETTINGS,
  jn as SHORTCUT,
  Mn as SIDEBAR,
  mn as SPACE,
  Gn as SPEED_MENU,
  Yn as START_AUTOSCROLL,
  ln as TOGGLE_CAPTIONS,
  Wn as TOGGLE_MUTED,
  Hn as TOGGLE_PLAY_PAUSE,
  gn as TRANSCRIPT_LINES,
  Bn as TRANSCRIPT_LINES_other,
  Zn as TRANSCRIPT_LOADING,
  Kn as TRANSCRIPT_LOAD_ERROR,
  Vn as TRANSCRIPT_OPTIONS,
  Fn as TRANSCRIPT_RETRY,
  Jn as TRANSCRIPT_UNAVAILABLE,
  $n as UP_ARROW,
  hn as VIDEO_SETTINGS,
  Qn as VOLUME,
  bn as VOLUME_VALUE,
  xn as default
};
